// Thin wrapper over `window.localStorage`. Feature code never reaches into
// `localStorage` directly — go through this module so the SSR-safety check
// and the swallow-on-error behaviour stay in one place.
//
// Sibling: `../cookies/cookieService.ts` is the equivalent for cookies.

const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

export const localStorageService = {
  getItem(key: string): string | null {
    if (!isBrowser) return null
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  },

  setItem(key: string, value: string): void {
    if (!isBrowser) return
    try {
      window.localStorage.setItem(key, value)
    } catch {
      // noop
    }
  },

  removeItem(key: string): void {
    if (!isBrowser) return
    try {
      window.localStorage.removeItem(key)
    } catch {
      // noop
    }
  },
} as const

export default localStorageService
